export default __webpack_public_path__ + "static/media/activities-footer-item.955478fc.svg";